/**
 * Sysadmin Studio Catalog → Skills route wrapper (PR-D refactor 2026-05-13).
 *
 * Thin wrapper that mounts the shared <SkillEditor scope="sysadmin" />.
 * All skills authoring logic lives in
 * `@/components/skill-editor-shared/SkillEditor.tsx` — this file's job
 * is just the TanStack file-route binding so the framework picks up
 * the route at /sysadmin/studio/skills.
 */
import { createFileRoute } from '@tanstack/react-router';
import { SkillEditor } from '@/components/skill-editor-shared/SkillEditor';

export const Route = createFileRoute('/sysadmin/studio/skills')({
  component: SysadminSystemSkillsPage,
});

function SysadminSystemSkillsPage() {
  return <SkillEditor scope="sysadmin" />;
}
